import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-jahiriat-jama-report',
  templateUrl: './jahiriat-jama-report.component.html',
  styleUrl: './jahiriat-jama-report.component.scss'
})
export class JahiriatJamaReportComponent {





  constructor(
    private dialogRef: MatDialogRef<JahiriatJamaReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
  ) {
  }


  advtFormBeans: any = []
  reportType: any
  startDate: any
  endDate: any
  repName: any
  offRepName: any
  advtName: any
  issueDates: any
  issueDates1: any


  monthlyTotals: { [key: string]: number } = {};
monthlyDngeeTotals: { [key: string]: number } = {};
grandTotal: number = 0;
grandDngeeTotal: number = 0;

  PaymentReceiptRegister = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    rep_name: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });
  startDate_contract: any;
  enddate_contract: any;
  advtVBTotal: number = 0;
  // PaymentadvtOffInDTotal3: number = 0;
  // PaymentadvtOffInDTotal: number = 0;
  ngOnInit(): void {
    let repname: any = this.data['repName'];

    if (repname != "") {
      repname = repname;
    }

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

    const req: any = {
      "rep_name": repname,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_name": "",
      "issue_date": this.issueDates
    };

    // 1. Generate dynamic headers before/during the service call
    if (this.startDate && this.endDate) {
      this.generateDynamicHeaders(this.startDate, this.endDate);
    }

   this.service.getAdvtjama(req).subscribe((data: any) => {
  console.log("ADVT Data=", data);

  // Initialize udhistha_monthly as empty object if missing
  this.advtFormBeans = data.map((office: any) => ({
    ...office,
    udhistha_monthly: office.udhistha_monthly
      ? Object.fromEntries(
          Object.entries(office.udhistha_monthly).map(([k, v]) => [String(k), v])
        )
      : {}
  }));

  this.advtVBTotal = 0;
  for (let office of this.advtFormBeans) {
    this.advtVBTotal += parseFloat(office.total) || 0;
  }

  this.calculateMonthlyTotals();
  this.cdr.detectChanges();
});
  }

  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  selectedMonths: any[] = [];

  generateDynamicHeaders(start: string, end: string) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const months = [];
    const monthNames = ["जानेवारी", "फेब्रुवारी", "मार्च", "एप्रिल", "मे", "जून", "जुलै", "ऑगस्ट", "सप्टेंबर", "ऑक्टोबर", "नोव्हेंबर", "डिसेंबर"];

    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    while (current <= endDate) {
      months.push({
        name: monthNames[current.getMonth()],
        // CONVERT TO STRING to match your JSON keys "4", "5", etc.
        index: (current.getMonth() + 1).toString()
      });
      current.setMonth(current.getMonth() + 1);
    }
    this.selectedMonths = months;
  }

  formatCurrency(value: number | null | undefined): string {

    if (!value || value === 0) return '';
    return value.toString();
  }



//   printPageA4Landscape(): void {
//   const printSection = document.getElementById('print-section');
//   if (!printSection) return;
//   const printWindow = window.open('', '', 'width=1400,height=900');
//   if (!printWindow) return;

//   printWindow.document.write(`
// <html>
//   <head>
//     <title>व्यवसाय अहवाल</title>
//     <style>
//       @page { size: A4 landscape; margin: 6mm; }
//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//       body {
//         font-size: 1px;
//         font-weight: bold;
//       }
//       table { border-collapse: collapse; width: 100%; }
//       th, td {
//         border: 1px solid #000;
//         padding: 4px;
//         font-size: 12px;
//         font-weight: bold;
//         text-align: center;
//       }
//       .amount-cell { text-align: right; }
//       .total-row { font-weight: bold; background: #f0f0f0; }
//     </style>
//   </head>
//   <body>${printSection.outerHTML}</body>
// </html>
// `);
//   printWindow.document.close();
//   setTimeout(() => {
//     printWindow.print();
//     printWindow.close();
//   }, 500);
// }

// printPageA4Landscape(): void {
//   const printSection = document.getElementById('print-section');
//   if (!printSection) return;
//   const printWindow = window.open('', '_blank', 'width=1400,height=900');
//   if (!printWindow) return;

//   printWindow.document.write(`
// <html>
//   <head>
//     <title>व्यवसाय अहवाल</title>
//     <style>
//       @page {
//         size: A4 landscape;
//         margin: 6mm;
//       }
//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//         box-sizing: border-box;
//       }
//       html, body {
//         width: 277mm;
//         height: 190mm;
//         margin: 0;
//         padding: 0;
//         font-size: 12px; /* ✅ Fixed: was 1px which broke all text */
//         font-weight: bold;
//       }
//       #print-section {
//         width: 100%;
//         overflow: hidden;
//       }
//       table {
//         border-collapse: collapse;
//         width: 100%;
//         table-layout: fixed; /* ✅ Prevents table overflow */
//       }
//       th, td {
//         border: 1px solid #000;
//         padding: 3px 4px;
//         font-size: 10px;
//         font-weight: bold;
//         text-align: center;
//         word-wrap: break-word;
//         overflow: hidden;
//       }
//       .amount-cell { text-align: right; }
//       .total-row {
//         font-weight: bold;
//         background: #f0f0f0 !important;
//       }

//       /* ✅ Force print layout when printing */
//       @media print {
//         html, body {
//           width: 277mm;
//           height: 190mm;
//           margin: 0;
//           padding: 0;
//           font-size: 10px;
//         }
//         table {
//           page-break-inside: auto;
//         }
//         tr {
//           page-break-inside: avoid;
//         }
//       }
//     </style>
//   </head>
//   <body>${printSection.outerHTML}</body>
// </html>
// `);

//   printWindow.document.close();

//   // ✅ Wait for full render before printing
//   printWindow.onload = () => {
//     setTimeout(() => {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }, 300);
//   };

//   // ✅ Fallback in case onload doesn't fire
//   setTimeout(() => {
//     if (!printWindow.closed) {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }
//   }, 1000);
// }

// printPageA4Landscape(): void {
//   const printSection = document.getElementById('print-section');
//   if (!printSection) return;
//   const printWindow = window.open('', '_blank', 'width=1400,height=900');
//   if (!printWindow) return;

//   printWindow.document.write(`
// <html>
//   <head>
//     <title>जाहिरात जमा अहवाल</title>
//     <style>
//       @page {
//         size: A4 landscape;
//         margin: 8mm;
//       }

//       * {
//         -webkit-print-color-adjust: exact !important;
//         print-color-adjust: exact !important;
//         box-sizing: border-box;
//         margin: 0;
//         padding: 0;
//       }

//       html, body {
//         width: 277mm;
//         margin: 0;
//         padding: 0;
//         font-family: Arial, sans-serif;
//         font-size: 10px;
//         color: #000 !important;
//         background: #fff !important;
//       }

//       #print-section {
//         width: 100%;
//       }

//       /* ── Header: center the title ── */
//       .report-header {
//         width: 100%;
//         margin-bottom: 6px;
//         border-bottom: 2px solid #000;
//         padding-bottom: 6px;
//       }

//       .header-row {
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         width: 100%;
//       }

//       .report-title {
//         font-size: 14px;
//         font-weight: bold;
//         color: #000 !important;
//         text-align: center;
//         width: 100%;
//       }

//       /* ── Table ── */
//       table {
//         border-collapse: collapse;
//         width: 100%;
//         table-layout: auto;
//       }

//       th, td {
//         border: 1px solid #000 !important;
//         padding: 3px 5px;
//         font-size: 9px;
//         font-weight: bold;
//         text-align: center;
//         color: #000 !important;
//         background: #fff !important;
//         white-space: nowrap;
//       }

//       /* ── All backgrounds forced white, all text black ── */
//       .table-header th {
//         background: #fff !important;
//         color: #000 !important;
//         font-weight: bold;
//         text-align: center;
//         border: 1px solid #000 !important;
//       }

//       .office-rep-header td,
//       .subtotal-row td,
//       .footer-row td,
//       .footer-label {
//         background: #fff !important;
//         color: #000 !important;
//         font-weight: bold;
//       }

//       .grand-total-row td {
//         background: #fff !important;
//         color: #000 !important;
//         font-weight: bold;
//       }

//       /* ── Amount cells right-aligned ── */
//       .cell-amount {
//         text-align: right !important;
//       }

//       .cell-center {
//         text-align: center !important;
//       }

//       .cell-label {
//         white-space: nowrap;
//       }

//       .cell-rep {
//         white-space: nowrap;
//         vertical-align: middle;
//         font-weight: bold;
//       }

//       /* ── Target input: show value cleanly ── */
//       .target-input {
//         border: none !important;
//         background: transparent !important;
//         font-size: 9px;
//         font-weight: bold;
//         color: #000 !important;
//         width: 100%;
//         text-align: right;
//       }

//       /* ── Hide action buttons ── */
//       .action-buttons,
//       .noPrint {
//         display: none !important;
//       }

//       /* ── Page break rules ── */
//       table { page-break-inside: auto; }
//       tr    { page-break-inside: avoid; }
//     </style>
//   </head>
//   <body>${printSection.outerHTML}</body>
// </html>
//   `);

//   printWindow.document.close();

//   printWindow.onload = () => {
//     setTimeout(() => {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }, 300);
//   };

//   // Fallback
//   setTimeout(() => {
//     if (!printWindow.closed) {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }
//   }, 1200);
// }


printPageA4Landscape(): void {
  const printSection = document.getElementById('print-section');
  if (!printSection) return;

  // ── Clone the DOM so we don't mutate the live UI ──
  const clone = printSection.cloneNode(true) as HTMLElement;

  // ── Replace every <input class="target-input"> with a <span> showing its value ──
  const liveInputs = printSection.querySelectorAll<HTMLInputElement>('input.target-input');
  const cloneInputs = clone.querySelectorAll<HTMLInputElement>('input.target-input');

 liveInputs.forEach((liveInput, i) => {
  const val = liveInput.value || '';
  const span = document.createElement('span');
  span.textContent = val;

  // ── Use the cell's computed font size instead of hardcoding 9px ──
  const computedSize = window.getComputedStyle(liveInput).fontSize;
  span.style.fontSize = computedSize || '12px';   /// match table font-size
  span.style.fontWeight = 'bold';
  span.style.color = '#000';
  cloneInputs[i].replaceWith(span);
});

  const printWindow = window.open('', '_blank', 'width=1400,height=900');
  if (!printWindow) return;

  printWindow.document.write(`
<html>
  <head>
    <title>जाहिरात जमा अहवाल</title>
    <style>
      @page {
        size: A4 landscape;
        margin: 8mm;
      }
      * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }
      html, body {
        width: 277mm;
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
        font-size: 14px;
        color: #000 !important;
        background: #fff !important;
      }
      #print-section {
        width: 100%;
      }
      .report-header {
        width: 100%;
        margin-bottom: 6px;
        border-bottom: 2px solid #000;
        padding-bottom: 6px;
      }
      .header-row {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      .report-title {
        font-size: 14px;
        font-weight: bold;
        color: #000 !important;
        text-align: center;
        width: 100%;
      }
      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: auto;
      }
      th, td {
        border: 1px solid #000 !important;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        color: #000 !important;
        background: #fff !important;
        white-space: nowrap;
      }
      .table-header th {
        background: #fff !important;
        color: #000 !important;
        font-weight: bold;
        text-align: center;
        border: 1px solid #000 !important;
      }
      .office-rep-header td,
      .subtotal-row td,
      .footer-row td,
      .footer-label {
        background: #fff !important;
        color: #000 !important;
        font-weight: bold;
      }
      .grand-total-row td {
        background: #fff !important;
        color: #000 !important;
        font-weight: bold;
      }
      .cell-amount {
        text-align: right !important;
      }
      .cell-center {
        text-align: center !important;
      }
      .cell-label {
        white-space: nowrap;
      }
      .cell-rep {
        white-space: nowrap;
        vertical-align: middle;
        font-weight: bold;
      }
      .action-buttons,
      .noPrint {
        display: none !important;
      }
      table { page-break-inside: auto; }
      tr    { page-break-inside: avoid; }
    </style>
  </head>
  <body>${clone.outerHTML}</body>
</html>
  `);

  printWindow.document.close();

  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  setTimeout(() => {
    if (!printWindow.closed) {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  }, 1200);
}


getTargetTotal(monthIndex: string): number {
  return this.advtFormBeans.reduce((sum: number, office: any) => {
    return sum + (parseFloat(office['target_' + monthIndex]) || 0);
  }, 0);
}


getMarathiYear(): string {
  if (!this.startDate || !this.endDate) return '';

  const marathiDigits: { [key: string]: string } = {
    '0': '०', '1': '१', '2': '२', '3': '३', '4': '४',
    '5': '५', '6': '६', '7': '७', '8': '८', '9': '९'
  };

  const toMarathi = (num: number): string =>
    num.toString().split('').map(d => marathiDigits[d]).join('');

  const start = new Date(this.startDate);
  const end = new Date(this.endDate);

  const startYear = start.getFullYear();
  const endYear = end.getFullYear();

  // If same year, just show one year
  if (startYear === endYear) {
    return toMarathi(startYear);
  }

  // Show range like २०२५-२०२६
  return `${toMarathi(startYear)}-${toMarathi(endYear)}`;
}

// getTotalUdhistha(): number {
//   return this.advtFormBeans.reduce((sum, office) => {
//     return sum + (parseFloat(office.udhistha) || 0);
//   }, 0);
// }


showValue(val: any): string {
  const num = parseFloat(val);
  if (!val || isNaN(num) || num === 0) return '';
  return num.toString();
}

// Add this method
saveUdhistha(office: any, monthIndex: string): void {
  const year = new Date(this.startDate).getFullYear();
  const req = {
    off_rep_name: office.office_rep,
    month_no: parseInt(monthIndex),
    year_no: year,
    udhistha: parseFloat(office.udhistha_monthly[monthIndex]) || 0
  };
  this.service.saveUdhisthaMonthwise(req).subscribe({
    next: () => console.log('Saved udhistha for', office.office_rep, monthIndex),
    error: (err) => console.error('Save failed', err)
  });
}

getTotalUdhistha(monthIndex?: string): number {
  if (monthIndex) {
    // Month-specific total
    return this.advtFormBeans.reduce((sum: number, office: any) => {
      return sum + (parseFloat(office.udhistha_monthly?.[monthIndex]) || 0);
    }, 0);
  }
  // Grand total: sum of all months across all reps (unique months only via selectedMonths)
  return this.advtFormBeans.reduce((sum: number, office: any) => {
    return sum + this.selectedMonths.reduce((mSum: number, m: any) => {
      return mSum + (parseFloat(office.udhistha_monthly?.[m.index]) || 0);
    }, 0);
  }, 0);
}


calculateMonthlyTotals() {
  this.monthlyTotals = {};
  this.monthlyDngeeTotals = {};
  this.grandTotal = 0;
  this.grandDngeeTotal = 0;

  for (let office of this.advtFormBeans) {
    for (let m of this.selectedMonths) {
      const val = parseFloat(office.monthly_data[m.index]) || 0;
      const dngeeVal = parseFloat(office.dngee_monthly[m.index]) || 0;
      this.monthlyTotals[m.index] = (this.monthlyTotals[m.index] || 0) + val;
      this.monthlyDngeeTotals[m.index] = (this.monthlyDngeeTotals[m.index] || 0) + dngeeVal;
    }
    this.grandTotal += parseFloat(office.total) || 0;
    this.grandDngeeTotal += parseFloat(office.total_dngee) || 0;
  }
}


// जाहिरात + देणगी for a specific month, for one office
getMonthCombinedTotal(office: any, monthIndex: string): number {
  const jahirat = parseFloat(office.monthly_data[monthIndex]) || 0;
  const dngee = parseFloat(office.dngee_monthly[monthIndex]) || 0;
  return jahirat + dngee;
}

// जाहिरात + देणगी grand total for one office (row-level एकूण)
getOfficeGrandCombinedTotal(office: any): number {
  const jahirat = parseFloat(office.total) || 0;
  const dngee = parseFloat(office.total_dngee) || 0;
  return jahirat + dngee;
}

}
